<div class="cv-review">
  <div class="cv-review__head">
    <span class="cv-review__count">
      {{
        'cvImport.review.acceptedOf'
          | translate
            : { accepted: acceptedCount(), total: section.entries.length }
      }}
    </span>
    @if (!section.single && section.entries.length > 1) {
      <div class="cv-review__bulk">
        <button mat-button type="button" (click)="setAll(true)">
          {{ 'cvImport.review.acceptAll' | translate }}
        </button>
        <button mat-button type="button" (click)="setAll(false)">
          {{ 'cvImport.review.rejectAll' | translate }}
        </button>
      </div>
    }
  </div>

  @for (entry of section.entries; track entry) {
    <div
      class="cv-review__entry"
      [class.cv-review__entry--rejected]="!entry.accepted"
      [class.cv-review__entry--invalid]="isInvalidAccepted(entry)"
    >
      <div class="cv-review__entry-head">
        @if (!section.single) {
          <span class="cv-review__entry-index">{{ $index + 1 }}</span>
        }
        @if (confidencePercent(entry) !== null) {
          <span class="cv-review__confidence" [title]="entry.source || ''">
            {{ 'cvImport.review.confidence' | translate }}
            {{ confidencePercent(entry) }}%
          </span>
        }
        <mat-slide-toggle
          class="cv-review__accept"
          [(ngModel)]="entry.accepted"
        >
          {{
            (entry.accepted
              ? 'cvImport.review.accepted'
              : 'cvImport.review.rejected'
            ) | translate
          }}
        </mat-slide-toggle>
      </div>

      <div class="cv-review__fields" [formGroup]="entry.form">
        @for (field of section.fields; track field.key) {
          @if (field.type === 'checkbox') {
            <mat-checkbox
              class="cv-review__checkbox"
              [formControlName]="field.key"
            >
              {{ field.labelKey | translate }}
            </mat-checkbox>
          } @else if (field.type === 'date') {
            <mat-form-field class="cv-review__field" appearance="outline">
              <mat-label>{{ field.labelKey | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                [formControlName]="field.key"
                [errorStateMatcher]="errorMatcher"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          } @else if (field.type === 'birthdate') {
            <mat-form-field class="cv-review__field" appearance="outline">
              <mat-label>{{ field.labelKey | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="birthdatePicker"
                [formControlName]="field.key"
                [max]="maxBirthdate"
                [readonly]="true"
                [errorStateMatcher]="errorMatcher"
              />
              @if (control(entry, field.key).value) {
                <button
                  mat-icon-button
                  matIconSuffix
                  type="button"
                  class="cv-review__clear"
                  [attr.aria-label]="'cvImport.review.clearDate' | translate"
                  (click)="clear(entry, field.key)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              }
              <mat-datepicker-toggle
                matIconSuffix
                [for]="birthdatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker
                #birthdatePicker
                startView="multi-year"
              ></mat-datepicker>
              @if (control(entry, field.key).hasError('matDatepickerMax')) {
                <mat-error>{{
                  'cvImport.validation.futureDate' | translate
                }}</mat-error>
              }
            </mat-form-field>
          } @else if (field.type === 'sprachen') {
            <mat-form-field
              class="cv-review__field cv-review__field--wide"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <mat-label>{{ field.labelKey | translate }}</mat-label>
              <input
                matInput
                [formControlName]="field.key"
                [errorStateMatcher]="errorMatcher"
              />
            </mat-form-field>
            <p class="cv-review__list-hint">
              {{ 'cvImport.review.listHint' | translate }}
            </p>
          } @else if (field.type === 'industries' || field.type === 'tasks') {
            <div class="cv-review__composite">
              <span class="cv-review__composite-label">{{
                field.labelKey | translate
              }}</span>
              @switch (field.type) {
                @case ('industries') {
                  <app-cv-industries-field
                    [control]="control(entry, field.key)"
                    [industries]="industries"
                  ></app-cv-industries-field>
                }
                @case ('tasks') {
                  <app-cv-tasks-field
                    [control]="control(entry, field.key)"
                    [skillList]="skillList"
                  ></app-cv-tasks-field>
                }
              }
            </div>
          } @else {
            <mat-form-field
              class="cv-review__field"
              [class.cv-review__field--wide]="
                field.type === 'textarea' || field.type === 'list'
              "
              appearance="outline"
              [subscriptSizing]="field.type === 'list' ? 'dynamic' : 'fixed'"
            >
              <mat-label>{{ field.labelKey | translate }}</mat-label>

              @switch (field.type) {
                @case ('textarea') {
                  <textarea
                    matInput
                    [formControlName]="field.key"
                    [rows]="field.rows || 4"
                    [errorStateMatcher]="errorMatcher"
                  ></textarea>
                }
                @case ('number') {
                  <input
                    matInput
                    type="number"
                    [formControlName]="field.key"
                    [errorStateMatcher]="errorMatcher"
                  />
                }
                @case ('list') {
                  <input
                    matInput
                    [formControlName]="field.key"
                    [errorStateMatcher]="errorMatcher"
                  />
                }
                @default {
                  <input
                    matInput
                    [formControlName]="field.key"
                    [errorStateMatcher]="errorMatcher"
                  />
                }
              }

              @if (control(entry, field.key).hasError('required')) {
                <mat-error>{{
                  'cvImport.validation.required' | translate
                }}</mat-error>
              }
              @if (control(entry, field.key).hasError('minlength')) {
                <mat-error>
                  {{
                    'cvImport.validation.minLength'
                      | translate
                        : {
                            min: control(entry, field.key).getError('minlength')
                              .requiredLength,
                          }
                  }}
                </mat-error>
              }
              @if (control(entry, field.key).hasError('maxlength')) {
                <mat-error>
                  {{
                    'cvImport.validation.maxLength'
                      | translate
                        : {
                            max: control(entry, field.key).getError('maxlength')
                              .requiredLength,
                          }
                  }}
                </mat-error>
              }
              @if (control(entry, field.key).hasError('min')) {
                <mat-error>
                  {{
                    'cvImport.validation.min'
                      | translate
                        : { min: control(entry, field.key).getError('min').min }
                  }}
                </mat-error>
              }
              @if (control(entry, field.key).hasError('maxItems')) {
                <mat-error>
                  {{
                    'cvImport.validation.maxItems'
                      | translate
                        : {
                            max: control(entry, field.key).getError('maxItems')
                              .max,
                          }
                  }}
                </mat-error>
              }
            </mat-form-field>

            @if (field.type === 'list') {
              <p class="cv-review__list-hint">
                {{ 'cvImport.review.listHint' | translate }}
              </p>
            }
          }
        }
      </div>

      @if (isInvalidAccepted(entry)) {
        <p class="cv-review__entry-warning">
          <mat-icon>error_outline</mat-icon>
          {{ 'cvImport.review.entryInvalid' | translate }}
        </p>
      }
    </div>
  }
</div>
